import { Button } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import React from "react";
import * as XLSX from "xlsx";

interface DemoExportExcelProps {
  onLySerial?: boolean;
}

export const DemoExportRequestTransfer: React.FC<DemoExportExcelProps> = ({
  onLySerial,
}) => {
  const handleGenerate = () => {
    // Tiêu đề cột
    const headers = ["Mã sản phẩm", "Số lượng"];

    const rows = [headers, ["ANTE0009", 2]];

    const worksheet = XLSX.utils.aoa_to_sheet(rows);
    const range = XLSX.utils.decode_range(worksheet["!ref"] ?? "");
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = {
        fill: {
          fgColor: { rgb: "FFFF00" },
        },
        font: {
          bold: true,
          color: { rgb: "000000" },
        },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } },
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    }

    worksheet["!cols"] = headers.map((header) => ({
      wch: header.length + 3,
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");
    XLSX.writeFile(workbook, "Mau Import Excel_tao YC dieu chuyen SL.xlsx");
  };
  return (
    <div>
      <Button
        leftSection={<IconDownload size={14} />}
        color="teal"
        size="xs"
        onClick={handleGenerate}
      >
        Tải file mẫu
      </Button>
    </div>
  );
};
